import { CUSTOMER_LIST_FILTERS } from './customers-list-filters'
import type { CustomerListValues } from './customers-list-filters'
import { getAnalyticsActor, posthog } from '@/lib/posthog'

/** Nơi đổi bộ lọc: lưới desktop, sheet mobile, tiêu đề cột nợ, chip, "Xoá lọc". */
export type CustomerListFilterSurface =
    'bar' | 'sheet' | 'column_header' | 'chip' | 'clear'

type FilterKey = keyof CustomerListValues

// Ô tìm kiếm không tính là thao tác lọc theo công nợ.
const TRACKED_KEYS = (
    Object.keys(CUSTOMER_LIST_FILTERS.fields) as FilterKey[]
).filter((key) => key !== 'q')

const amountOrNull = (value: string) => (value === '' ? null : Number(value))

/**
 * Nhân viên có lọc/sắp xếp danh sách khách theo công nợ không. Chỉ gửi tên bộ
 * lọc, kiểu sắp xếp và mốc nợ Từ/Tới (số VND người dùng tự gõ) — không id
 * nhóm, không tên khách, không nợ của khách nào.
 */
export function captureCustomerListFiltersChanged(input: {
    before: CustomerListValues
    after: CustomerListValues
    surface: CustomerListFilterSurface
}) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        const { before, after } = input
        const changed = TRACKED_KEYS.filter((key) => before[key] !== after[key])
        if (changed.length === 0) return
        posthog.capture('customer_list_filters_changed', {
            schema_version: 1,
            event_id: crypto.randomUUID(),
            ...actor,
            route_template: '/customers',
            surface: input.surface,
            changed_keys: changed,
            sort: after.sort,
            debt_min: amountOrNull(after.debt_min),
            debt_max: amountOrNull(after.debt_max),
            has_debt: after.has_debt !== '',
            group_filtered: after.group_id !== 'all',
        })
    } catch {
        // Analytics must never block filtering.
    }
}
